import { render, staticRenderFns } from "./OtherDescription.vue?vue&type=template&id=4805433a"
import script from "./OtherDescription.vue?vue&type=script&lang=js"
export * from "./OtherDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports